import React, { Component } from 'react';
import { observer } from 'mobx-react';
import classNames from 'classnames';
import { translate } from 'react-switch-lang';
import '../../../images/smiley.png';
import '../../../images/logo_small.png';
import authStorage from '../../storages/mobx/authStorage';
import emojiTranslate from '../../helpers/emojiTranslate';
import Message from './messages/Message';

class OutgoingMessage extends Component {
  render() {
    const {
      message, sender, sender_account, status, t, created_at, fullMessage, id: messageID, conversation_id,
    } = this.props;
    // const senderUser = usersStorage.getUserByID(sender);
    const {
      id, name, surname, avatar,
    } = sender_account;
    const displayName = id == authStorage.id
      ? `${created_at.getDate()}.${created_at.getMonth() + 1} ${created_at.getHours() < 10 ? `0${created_at.getHours()}` : created_at.getHours()}:${created_at.getMinutes() < 10 ? `0${created_at.getMinutes()}` : created_at.getMinutes()}`
      : `${name || ''} ${surname || ''} (${created_at.getDate()}.${created_at.getMonth() + 1} ${created_at.getHours() < 10 ? `0${created_at.getHours()}` : created_at.getHours()}:${created_at.getMinutes() < 10 ? `0${created_at.getMinutes()}` : created_at.getMinutes()})`;
    let messageStatus = '';
    switch (status) {
      case 1000000:
        messageStatus = t('Failed');
        break;
      case 2:
        messageStatus = t('Seen');
        break;
      case 1:
        messageStatus = t('Delivered');
        break;
      case 0:
        messageStatus = t('Sended');
        break;
      default:
        messageStatus = '-';
    }
    const containerClass = classNames({
      'flex-col': true,
      'area-content-message-right': true,
      'message-unsubscribed': status < 0,
      'message-received': status == 0,
      'message-delivered': status == 1,
      'message-seen': status == 2,
      'message-failed': status == 1000000,
    });
    const statusClass = classNames({
      'message-unsubscribed': status < 0,
      'message-received': status == 0,
      'message-delivered': status == 1,
      'message-seen': status == 2,
      'message-failed': status == 1000000,
    });
    const displayMessage = emojiTranslate(message);
    return (
      <div className={containerClass} id={`message-${conversation_id}-${messageID}`}>
        <div>
          <p className="area-content-message_name">
            {displayName}
          </p>
        </div>
        <Message
          type={fullMessage.type}
          text={displayMessage}
          thumbnail={fullMessage.thumbnail}
          media={fullMessage.url}
          url={fullMessage.url}
          filename={fullMessage.filename}
          messageId={messageID}
          local
        />
        <div className={`message-status ${statusClass}-text`}>{messageStatus}</div>
        {status == -1 && <p className="text-truncate_area error">{t('chat.Try send to unsubscribed user')}</p>}
        <div className="message-user-image">
          <img src={avatar || '/images/logo_small.png'} alt="" />
        </div>
      </div>
    );
  }
}

OutgoingMessage.propTypes = {};

export default translate(observer(OutgoingMessage));
